(() => {
  const initTournaments = (root) => {
    const sections = root
      ? [root]
      : Array.from(document.querySelectorAll('.tournaments-section:not([data-tournaments-initialized])'));

    sections.forEach((section) => {
      const filterButtons = Array.from(section.querySelectorAll('[data-division-filter]'));
      const cards = Array.from(section.querySelectorAll('[data-tournament-card]'));
      const statusEl = section.querySelector('[data-tournament-filter-status]');

      section.dataset.tournamentsInitialized = 'true';

      if (!filterButtons.length || !cards.length) {
        return;
      }

      const applyFilter = (division) => {
        let visibleCount = 0;

        cards.forEach((card) => {
          const cardDivisions = (card.dataset.divisions || '')
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean);
          const isMatch = division === 'all' || cardDivisions.includes(division);

          card.hidden = !isMatch;
          card.classList.toggle('tournaments-list__item--hidden', !isMatch);

          if (isMatch) {
            visibleCount += 1;
          }
        });

        filterButtons.forEach((button) => {
          const isActive = button.dataset.divisionFilter === division;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (statusEl) {
          if (division === 'all') {
            statusEl.hidden = true;
            statusEl.textContent = '';
          } else {
            statusEl.hidden = false;
            statusEl.textContent =
              visibleCount === 0
                ? 'No tournaments match this division.'
                : `${visibleCount} tournament${visibleCount === 1 ? '' : 's'} found.`;
          }
        }
      };

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          applyFilter(button.dataset.divisionFilter || 'all');
        });
      });

      applyFilter('all');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTournaments());
  } else {
    initTournaments();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.tournaments-section');
    if (section) {
      section.removeAttribute('data-tournaments-initialized');
      initTournaments(section);
    }
  });
})();
